export const selector = ({ appConfiguration, places, checkout }) => ({
  phoneTypes: appConfiguration.sharedConfig.phoneTypes,
  localize: appConfiguration.localize,
  userData: checkout.requestData,
  rooms: checkout.selectedAvailability.hotelInformation.rooms,
  places
});
